import { FixedObject, FluidObject } from "gatsby-image"

export const fluidWithIdentifier = (id: string, data: object) => {
  return data[id].childImageSharp.fluid as FluidObject
}

export const fixedWithIdentifier = (id: string, data: object) => {
  return data[id].childImageSharp.fixed as FixedObject
}
